import { __assign, __extends } from "tslib";
import * as React from 'react';
import { st, classes } from './Checkbox.st.css';
import { noop } from '../../utils';
import { filterDataProps } from '../../utils/filter-data-props';
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusedByMouse = false;
        _this.state = { isFocused: false, focusVisible: false };
        _this.handleMouseDown = function (e) {
            //When clicking on the label, the input loses focus style state and then gains it again.
            //To prevent this we disable the default mouse down behavior and set the state to true
            if (!_this.props.disabled) {
                e.preventDefault();
                _this.focusedByMouse = true;
                _this.setState({ isFocused: true });
            }
        };
        _this.handleChange = function (e) {
            _this.props.onChange(__assign({ checked: !_this.props.checked }, e));
        };
        _this.handleInputKeyDown = function () {
            _this.setState({ focusVisible: true });
        };
        _this.handleInputBlur = function (event) {
            _this.state.isFocused &&
                _this.setState({ isFocused: false, focusVisible: false });
            _this.focusedByMouse = false;
            _this.props.onBlur && _this.props.onBlur(event);
        };
        _this.handleInputFocus = function (event) {
            !_this.focusedByMouse &&
                _this.props.onFocusByKeyboard &&
                _this.props.onFocusByKeyboard(event);
            _this.setState({ isFocused: true, focusVisible: !_this.focusedByMouse });
        };
        return _this;
    }
    Checkbox.prototype.focus = function () {
        var _a;
        (_a = this.checkbox) === null || _a === void 0 ? void 0 : _a.focus();
    };
    ;
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, checked = _a.checked, disabled = _a.disabled, error = _a.error, indeterminate = _a.indeterminate, indeterminateIcon = _a.indeterminateIcon, checkedIcon = _a.checkedIcon, uncheckedIcon = _a.uncheckedIcon;
        return (React.createElement("label", __assign({ className: st(classes.root, {
                checked: checked,
                disabled: disabled,
                focus: this.state.isFocused,
                readonly: this.props.readOnly,
                error: error,
                indeterminate: indeterminate,
                'focus-visible': this.state.focusVisible,
            }, this.props.className), onMouseDown: this.handleMouseDown }, filterDataProps(this.props)),
            React.createElement("input", __assign({ type: "checkbox", className: classes.nativeCheckbox, onClick: function (e) { return e.stopPropagation(); }, onChange: this.handleChange, onKeyDown: this.handleInputKeyDown, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, ref: function (ref) { return (_this.checkbox = ref); }, 
                //temp fix
                checked: checked, disabled: disabled, readOnly: this.props.readOnly, tabIndex: this.props.tabIndex, id: this.props.id, required: this.props.required, autoFocus: this.props.autoFocus, name: this.props.name, "aria-controls": this.props['aria-controls'], "aria-label": this.props['aria-label'], "aria-invalid": this.props['aria-invalid'], "aria-describedby": this.props['aria-describedby'] }, (indeterminate && {
                'aria-checked': 'mixed'
            }))),
            React.createElement("span", { className: classes.box }, this.props.indeterminate
                ? indeterminateIcon
                : this.props.checked
                    ? checkedIcon
                    : uncheckedIcon),
            this.props.children ? (React.createElement("div", { className: classes.childContainer }, this.props.children)) : null));
    };
    Checkbox.displayName = 'Checkbox';
    Checkbox.defaultProps = {
        onChange: noop,
        checked: false,
        indeterminate: false,
        tabIndex: 0,
        onBlur: noop,
    };
    return Checkbox;
}(React.Component));
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map